(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("galore", [], factory);
	else if(typeof exports === 'object')
		exports["galore"] = factory();
	else
		root["galore"] = root["galore"] || {}, root["galore"]["PlaygroundPage"] = factory();
})(this, () => {
return 